export default class ProductGrid {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
  }
}
